var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFBF1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5H24V12.5C24 11.39 23.11 10.5 22 10.5H18C16.89 10.5 16 11.39 16 12.5V14.5H12C10.89 14.5 10.01 15.39 10.01 16.5L10 27.5C10 28.61 10.89 29.5 12 29.5H28C29.11 29.5 30 28.61 30 27.5V16.5C30 15.39 29.11 14.5 28 14.5ZM22 14.5H18V12.5H22V14.5Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/Symbol.6ff46ef067a25bc1a4e657c060270011.svg";
export { ForwardRef as ReactComponent };